<template>
  <div>
    <div class="px-4 sm:px-6">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        <template v-for="tab in tabs">
          <span
            v-if="activeTab && tab.name === activeTab.name"
            :key="tab.name"
            class="whitespace-nowrap flex py-3 px-1 border-b-2 font-medium text-sm border-indigo-500 text-indigo-600 cursor-default"
          >
            {{ tab.label }}
          </span>
          <a
            v-else
            :key="tab.name"
            role="button"
            class="whitespace-nowrap flex py-3 px-1 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200"
            @click="handleChange(tab)"
          >
            {{ tab.label }}
          </a>
        </template>
      </nav>
    </div>
    <div v-if="activeTab && activeTab.children" class="border-t">
      <Tabs :key="activeTab.name" :tabs="activeTab.children" />
    </div>
  </div>
</template>

<script>
const findActiveTab = (tabs, view, parent = null) => {
  for (const tab of tabs) {
    if (view === tab.view) {
      return parent || tab;
    }

    const parentTab = findActiveTab(tab.children || [], view, tab);

    if (parentTab) {
      return parentTab;
    }
  }

  return null;
};

const findDefaultView = (tabs) => {
  for (const tab of tabs) {
    if ('view' in tab) {
      return tab.view;
    }

    const view = findDefaultView(tab.children || []);

    if (view) {
      return view;
    }
  }

  return null;
};

export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTab: '',
    };
  },
  created() {
    this.activeTab = findActiveTab(this.tabs, this.$route.params.view);
  },
  methods: {
    handleChange(newActiveTab) {
      const view = newActiveTab?.view || findDefaultView(newActiveTab?.children || []);
      if (view) {
        this.$router.replace({
          name: this.$route.name,
          params: {
            ...this.$route.params,
            view,
          },
        });
      }
    },
  },
};
</script>
